module.exports = __webpack_public_path__ + "static/img/tx.31cb44cc.png";